<template>
  <section :class="!pastOrders ? 'acc-sect-wrapper' : ''" class="margin-bottom-xl">
    <div class="section-header margin-bottom-s grid-x">
      <h3>{{ PURCHASE_HISTORY.purchaseHistoryLabel }}</h3>
      <div v-if="pastOrders" class="cell auto margin-left-xs">
        <a href="/purchases/online?linklocation=pagecontent" class="secondary-cta">View all</a>
      </div>
    </div>

    <div v-if="orderHistory.orders === null && !orderHistory.notification.type">
      <Skeleton height="160px" />
    </div>

    <template v-else>
      <template v-if="!pastOrders && orderHistory.notification.type">
        <Notification :severity="orderHistory.notification.type" :closable="false">
          <div class="grid-y">
            <div class="notification-heading">Service Interruption</div>
            <div class="notification-text">
              <p>{{ orderHistory.notification.message }}</p>
              <p class="notification-redirect">Go to <a href="/purchases/online?linklocation=pagecontent">Order History</a></p>
            </div>
          </div>
        </Notification>
      </template>

      <template v-if="!pastOrders && !orderHistory.notification.type">
        <NoOrderHistoryCard />
      </template>

      <div v-if="pastOrders && !orderHistory.notification.message" class="orders">
        <Carousel :list="filteredOrderHistory()">
          <template #item="slotProps">
            <OrderHistoryCard :order="slotProps.data" :my-account-get-thumbnail-enabled="myAccountGetThumbnailEnabled" />
          </template>
        </Carousel>
      </div>
    </template>
  </section>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { Cookie } from '@vue-util/cookie';
import Carousel from '@atomic-ui/carousel/Carousel';
import Notification from '@atomic-ui/notification/Notification';
import Skeleton from '@atomic-ui/skeleton/Skeleton';
import { useDashboardStore } from '@/stores/useDashboardStore';
import { onlineUid, PURCHASE_HISTORY } from 'config';
import OrderHistoryCard from './OrderHistoryCard';
import NoOrderHistoryCard from './NoOrderHistoryCard';

const maxDisplay = 3;
const dashboardStore = useDashboardStore();
const { orderHistory, killswitches } = storeToRefs(dashboardStore);
const myAccountGetThumbnailEnabled = computed(() => killswitches.value?.myAccountGetThumbnailEnabled);
const pastOrders = computed(() => orderHistory.value.orders && orderHistory.value.orders.length > 0);

onMounted(async () => {
  const userId = Cookie.get(onlineUid);

  if (myAccountGetThumbnailEnabled.value) {
    await dashboardStore.fetchOrderHistoryThumbnails({ userId });
  }
});

const filteredOrderHistory = () => {
  if (myAccountGetThumbnailEnabled.value && orderHistory.value.orders.length) {
    return orderHistory.value.orders.slice(0, maxDisplay);
  }
  return orderHistory.value.orders;
};
</script>

<style lang="scss" scoped>
@import '~settingSCSS';

.notification-redirect {
  margin-bottom: 0;
}
.section-header {
  align-items: baseline;
}
</style>
